module.exports = __webpack_public_path__ + "static/Glossary-dd87ce58e359cdcdb226097de673c8eb.pdf";